import { useTranslation } from "hhn-commons";
import {
  UnreadIndicatorIcon,
  UnreadIndicatorText,
  UnreadIndicatorWrapper,
} from "./UnreadMessagesIndicator.style";

/**
 * Passive top-of-panel hint shown while unread messages sit above the viewport
 * and the user hasn't reached them yet. Informational only (pointer-events:
 * none) — it does not jump. It auto-hides once the first unread scrolls into
 * view.
 */
function UnreadMessagesIndicator() {
  const { t } = useTranslation();
  const label = t("newMessagesDivider", { ns: "message" });

  return (
    <UnreadIndicatorWrapper data-testid="unread-messages-indicator">
      <UnreadIndicatorIcon />
      <UnreadIndicatorText>{label}</UnreadIndicatorText>
    </UnreadIndicatorWrapper>
  );
}

export default UnreadMessagesIndicator;
